import { isEmpty } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import constants from "../../utils/constants";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
const HierarchyNew = ({ parmas }) => {
  let { user } = useContext(AuthContext);
  const [profile, setProfile] = useState({});
  const getUsers = async () => {
    const { status, data: response_users } = await apiGet(apiPath.userProfile, {
      user_id: parmas?.id,
    });
    if (status === 200) {
      if (response_users.success) {
        setProfile(response_users?.results);
      }
    }
  };
  useEffect(() => {
    if (!isEmpty(parmas?.id)) {
      getUsers();
    }
  }, [parmas?.id]);
  useEffect(() => {
    
      getUsers();
    
  }, []);
// console.log("profile",profile);
let userStatus = {
  owner: "OW",
  sub_owner: "SOW",
  super_admin: "SSSSS",
  admin: "SSSS",
  sub_admin: "SSS",
  senior_super: "SS",
  super_agent: "SUP",
  agent: "MA",
  user: "PL",
};

if (user?.userType === "sub_owner") {
  userStatus = {
    sub_owner: "SOW",
    super_admin: "SSSSS",
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };
} else if (user?.userType === "super_admin") {
  userStatus = {
    super_admin: "SSSSS",
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };
} else if (user?.userType === "admin") {
  userStatus = {
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: " PL",
  };
} else if (user?.userType === "sub_admin") {
  userStatus = {
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };
} else if (user?.userType === "senior_super") {
  userStatus = {
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };
} else if (user?.userType === "super_agent") {
  userStatus = {
    
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };
}
// console.log(profile,"profile",user.userType in profile )

  return (
    <div className="agent-path mb-1">
    
        <ul className="m-0 list-unstyled">
          {/* <li>
          <Link
                  to={`/${user?._id}/${
                    user?.userType || ""
                  }`}
                >
                  <span className={userStatus[user?.userType]}>
                    {userStatus[user?.userType]}
                  </span>
                  <strong>{user?.username || ""}</strong>
                </Link>
          </li> */}
          {!isEmpty(profile) && user.userType in profile  && Object.keys(userStatus).map((u_type) => {
            console.log('u_type0',u_type)
            return !isEmpty(profile[u_type]) && u_type != "owner" ? (
              <li>
                <Link
                  to={`/${profile[u_type]._id}/${
                    profile[u_type]?.userType || ""
                  }`}
                >
                  <span className={userStatus[u_type]}>
                    {userStatus[u_type]}
                  </span>
                  <strong>{profile[u_type]?.username || ""}</strong>
                </Link>
              </li>
            ) : null;
          })}
          {profile?.userType && (
            <>
              <li>
                <Link to={`/${profile._id}/${profile?.userType || ""}`}>
                  <span className={constants.user_status[profile?.userType]}>
                    {constants.user_status[profile?.userType]}
                  </span>
                  <strong>{profile?.username || ""}</strong>
                </Link>
              </li>
            </>
          )}
        </ul>
      
    </div>
  );
};

export default HierarchyNew;
